module.exports = __webpack_public_path__ + "static/media/pinkeye.49d7723e.jpeg";